import React from 'react';
import { useHasAccessTo } from 'Authorized';

interface Props {
	to: string | undefined | Array<string>;
	fallback?: React.ReactElement | string;
}

const Authorized: React.FC<Props> = ({ to, children, fallback = '' }) => {
	const hasAccessTo = useHasAccessTo();
	if (!to) return <>{children}</>;
	return hasAccessTo(to) ? <>{children}</> : <>{fallback}</>;
};

export default Authorized;
